// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"e31d3597","710":"8643b91c","983":"84ec0635"}[chunkId] + ".chunk.js";
};